import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import DropDownList from "../../../../ReusableComponents/DropDownList/DropDownList";
import SmartDownloadPagination from "../../../../components/SmartDataTable/SmartDownloadPagination";
import {
  MASTER_DATABASE_COLUMNS,
  MASTER_DATABASE_CONFIG,
  MASTER_DATABASE_SEARCHABLE_FIELDS,
} from "./MasterDataBaseConstants";

export default function ListMasterDataBase({ token }) {
  const dispatch = useDispatch();

  const updateCandidateField = async (payload, url) => {
    try {
      const res = await nodeinstance.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status === 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const renderCustomCell = useCallback(
    (item, column, rowIndex, currentPage, pageSize) => {
      if (column.key === "serial") {
        return (currentPage - 1) * pageSize + rowIndex + 1;
      }

      if (column.key === "covid_vaccine_action") {
        return (
          <DropDownList
            value={item.covid_vaccine || ""}
            presetValues={[
              { value: "NONE" },
              { value: "DOSE 1" },
              { value: "DOSE 2" },
              { value: "Fully Vaccinated" },
            ]}
            setValue={(event) => {
              updateCandidateField(
                {
                  candidateId: item.candidate_id,
                  covidVaccine: event.target.value,
                },
                "/arrivedCandidates/updateCovidVaccine"
              );
            }}
          />
        );
      }

      if (column.key === "blood_group_action") {
        return (
          <DropDownList
            value={item.blood_group || ""}
            presetValues={[
              { value: "A+" },
              { value: "A-" },
              { value: "B+" },
              { value: "B-" },
              { value: "AB+" },
              { value: "AB-" },
              { value: "O+" },
              { value: "O-" },
            ]}
            setValue={(event) => {
              updateCandidateField(
                {
                  candidateId: item.candidate_id,
                  bloodGroup: event.target.value,
                },
                "/arrivedCandidates/updateBloodGroup"
              );
            }}
          />
        );
      }

      return null;
    },
    [token, dispatch]
  );

  const handleDownloadComplete = useCallback(
    (result) => {
      dispatch(
        setAppError({
          msg: `Excel Downloaded (${result.recordCount} records)`,
          color: "success",
        })
      );
    },
    [dispatch]
  );

  const handleDownloadError = useCallback(
    (error) => {
      dispatch(
        setAppError({
          msg: error.message || "Download failed",
          color: "error",
        })
      );
    },
    [dispatch]
  );

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <SmartDownloadPagination
        // API Configuration
        apiEndpoint={MASTER_DATABASE_CONFIG.API_ENDPOINT}
        downloadEndpoint={MASTER_DATABASE_CONFIG.DOWNLOAD_ENDPOINT}
        token={token}
        
        // Table Configuration
        columns={MASTER_DATABASE_COLUMNS}
        searchableFields={MASTER_DATABASE_SEARCHABLE_FIELDS}
        layoutType="table"
        enableHighlighting={true}
        
        // Pagination Configuration
        defaultPageSize={MASTER_DATABASE_CONFIG.DEFAULT_PAGE_SIZE}
        pageSizeOptions={MASTER_DATABASE_CONFIG.PAGE_SIZE_OPTIONS}
        
        // Download Configuration
        downloadFilename={MASTER_DATABASE_CONFIG.DOWNLOAD_FILENAME}
        enableDownload={true}
        
        // Search Configuration
        enableSearch={true}
        searchPlaceholder={MASTER_DATABASE_CONFIG.SEARCH_PLACEHOLDER}
        searchDebounceMs={MASTER_DATABASE_CONFIG.DEBOUNCE_MS}
        
        // Customization
        renderCustomCell={renderCustomCell}
        
        // Event Handlers
        onDownloadComplete={handleDownloadComplete}
        onDownloadError={handleDownloadError}
        
        // Additional Props
        noDataMessage={MASTER_DATABASE_CONFIG.NO_DATA_MESSAGE}
        className="master-database-table"
      />
    </div>
  );
}
